import {
  Box,
  Button,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerHeader,
  DrawerOverlay,
  DrawerProps,
  Flex,
  HStack,
  Input,
  List,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Table,
  TableContainer,
  Tabs,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Image,
} from "@chakra-ui/react";
import {
  IChiTietDinhGia,
  IChiTietThuaDat,
  IDinhGia,
  IDisplayGeo,
  IDropdownItem,
  IShapeFile,
  IThuaDatIdentity,
} from "../_types_";
import { useEffect, useState } from "react";
import UploadMutiFile from "./UploadFileShape";
import ArcgisHelper from "../arcgis/ArcgisHelper";
import { getThuaShapeFile } from "../apis/giadat.api";
import Dropdown from "./Dropdown";
import { numberFormat } from "../utils";

interface IProps extends Omit<DrawerProps, "children">, IThuaDatIdentity {
  setSelectedGeometries: (data: IDisplayGeo[]) => void;
  arc: ArcgisHelper | undefined;
}

export default function DinhGiaFromFile({
  isOpen,
  onClose,
  maHuyen,
  maXa,
  soTo,
  soThua,
  setSelectedGeometries: parentSelectedGeometries,
  arc,
}: IProps) {
  const [thuaFromFile, setthuaFromFile] = useState<IShapeFile>();
  const [thuaSelectIndex, setThuaSelectIndex] = useState(0);
  const [thuaDatChiTiets, setThuaDatChiTiets] = useState<IChiTietThuaDat[]>();
  const [selectedthuaDatChiTiet, setSelectedthuaDatChiTiet] =
    useState<IChiTietThuaDat>();

  const [dsDinhGia, setDsDinhGia] = useState<IDropdownItem[]>([]);

  const [dinhGia, setDinhGia] = useState<IDinhGia>();
  const [indexDinhGia, setIndexDinhGia] = useState(0);
  const [chiTiet, setChiTiet] = useState<IChiTietDinhGia[]>([]);
  const [mdsd, setMdsd] = useState<IDropdownItem[]>([]);
  function geoFromDinhGia() {
    const dinhGiaSelect = selectedthuaDatChiTiet?.dinhGias[indexDinhGia];
    let geos: IDisplayGeo[] = [];
    if (dinhGiaSelect && dinhGiaSelect.geometries) {
      geos = dinhGiaSelect?.geometries?.map((q) => {
        const dgeo: IDisplayGeo = {
          color: q.color,
          geo: q.geometry,
        };
        return dgeo;
      });
    }

    //route geo
    // const routeGeo = dinhGiaSelect?.routeGeometries;
    // if (routeGeo && routeGeo.length > 0) {
    //   const dRGeo = routeGeo.map((m) => {
    //     const dgeo: IDisplayGeo = {
    //       color: "",
    //       geo: m,
    //     };
    //     return dgeo;
    //   });
    //   geos.push(...dRGeo);
    // }
    return geos;
  }
  useEffect(() => {
    try {
      if (!arc || !thuaFromFile) return;
      arc.drawGeometries(
        thuaFromFile?.thuaDats?.map((m) => {
          return { color: "", geo: m.geometry };
        })
      );
    } catch (er) {
      console.log("lỗi đọc file", er);
    }
  }, [arc, thuaFromFile]);

  useEffect(() => {
    if (arc && thuaFromFile) {
      const thua = thuaFromFile?.thuaDats[thuaSelectIndex];
      const geos = [{ color: "", geo: thua?.geometry || "" }];
      arc.drawGeometries(geos);
    }
  }, [arc, thuaFromFile, thuaSelectIndex]);

  useEffect(() => {
    if (!thuaFromFile) return;
    getDinhGiaFromFile(thuaFromFile?.fileId);
  }, [thuaFromFile]);

  useEffect(() => {
    if (!thuaDatChiTiets) return;
    else {
      setSelectedthuaDatChiTiet(thuaDatChiTiets[0]);
    }
  }, [thuaDatChiTiets]);

  const getDinhGiaFromFile = async (fileId: string) => {
    try {
      let tempdgs = await getThuaShapeFile(maHuyen, maXa, soTo, soThua, fileId);
      setThuaDatChiTiets(tempdgs);
    } catch (er) {
      console.log(er);
    }
  };
  useEffect(() => {
    if (!selectedthuaDatChiTiet) return;
    setDsDinhGia(
      selectedthuaDatChiTiet.dinhGias?.map((p, index) => {
        const item: IDropdownItem = {
          lable: `${p.tenDuong} ${
            p.tenHem ?? p.chieuDaiHem ? p.chieuDaiHem : ""
          }`,
          value: index,
        };
        return item;
      })
    );
    const mdResult = selectedthuaDatChiTiet.thuaDat.mucDichSuDungs.map((p) => {
      const item: IDropdownItem = {
        value: p.kyHieu,
        lable: p.kyHieu,
      };
      return item;
    });
    setMdsd(mdResult);
    setChiTiet(selectedthuaDatChiTiet.dinhGias[0].chiTiets);
    setIndexDinhGia(0);
    setDinhGia(selectedthuaDatChiTiet.dinhGias[0]);
  }, [selectedthuaDatChiTiet]);

  useEffect(() => {
    const dinhGiaSelect = selectedthuaDatChiTiet?.dinhGias[indexDinhGia];
    const dGeos = geoFromDinhGia();
    if (dGeos) {
      //arc?.drawGeometries(dGeos);
      parentSelectedGeometries(dGeos);
      setChiTiet(dinhGiaSelect?.chiTiets || []);
      setDinhGia(dinhGiaSelect);
    }
  }, [indexDinhGia, selectedthuaDatChiTiet]);

  const handleChangeValue = (
    index: number,
    val: string | number,
    type: "MDSD" | "DIEN_TICH" | "GIA"
  ) => {
    const newChiTiet = [...chiTiet];
    switch (type) {
      case "MDSD": {
        newChiTiet[index].mdsd = val.toString();
        break;
      }
      case "DIEN_TICH": {
        newChiTiet[index].dienTich = Number.parseFloat(val.toString());
        break;
      }
      case "GIA": {
        newChiTiet[index].gia = Number.parseFloat(val.toString());
        tinhGiaMoi(newChiTiet);
        break;
      }
      default:
        break;
    }
    setChiTiet(newChiTiet);
  };
  const tinhGiaMoi = (chiTiet: IChiTietDinhGia[]) => {
    if (!dinhGia) return;
    let tongChiTiet = 0;
    chiTiet.forEach((p) => (tongChiTiet += p.gia));
    let tongGia = tongChiTiet * dinhGia.heSoTiepGiapDuong;
    setDinhGia({ ...dinhGia, tongGia });
  };

  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="right"
        onClose={() => {
          setthuaFromFile(undefined);
          setDinhGia(undefined);
          setChiTiet([]);
          onClose();
        }}
        //finalFocusRef={btnRef}
        size="lg"
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>{`Định giá thửa hình thành trong tương lai`}</DrawerHeader>
          <DrawerBody>
            <Flex
              w="full"
              flexDirection="column"
              mt="20px"
              border="1px solid #fff"
              padding="5px"
              borderRadius="5px"
              boxShadow="base"
            >
              <UploadMutiFile
                title="chọn shape file"
                onUploadSuccess={(f) => {
                  if (typeof f !== "string") setthuaFromFile(f);
                }}
              />
              <TableContainer w="full">
                <Table size="sm">
                  <Thead>
                    <Tr>
                      <Th>Số tờ</Th>
                      <Th>Số thửa</Th>
                      <Th>MĐSD</Th>
                      <Th>Diện tích</Th>
                      <Th></Th>
                    </Tr>
                  </Thead>
                  <Tbody>
                    {thuaFromFile?.thuaDats?.map((p, index) => {
                      return (
                        <Tr
                          key={String(index)}
                          onClick={() => {
                            setThuaSelectIndex(index);
                            if (thuaDatChiTiets)
                              setSelectedthuaDatChiTiet(thuaDatChiTiets[index]);
                          }}
                        >
                          <Td bg={index === thuaSelectIndex ? "#bee3f8" : ""}>
                            {p.attributes.shbando}
                          </Td>
                          <Td bg={index === thuaSelectIndex ? "#bee3f8" : ""}>
                            {p.attributes.shthua}
                          </Td>
                          <Td
                            bg={index === thuaSelectIndex ? "#bee3f8" : ""}
                          ></Td>
                          <Td bg={index === thuaSelectIndex ? "#bee3f8" : ""}>
                            {p.attributes.dientich}
                          </Td>
                        </Tr>
                      );
                    })}
                  </Tbody>
                </Table>
              </TableContainer>
              <Box w="full" border="2px solid #fff" boxShadow="base">
                <TableContainer w="full">
                  <Table size="sm">
                    <Tbody>
                      <Tr>
                        <Th w="30%">Định giá:</Th>
                        <Td>
                          <Dropdown
                            data={dsDinhGia}
                            selectedVal={indexDinhGia}
                            onChange={(val) => setIndexDinhGia(val as number)}
                          />
                        </Td>
                      </Tr>
                      <Tr>
                        <Th>Tên đường:</Th>
                        <Td>{dinhGia?.tenDuong}</Td>
                      </Tr>
                      <Tr>
                        <Th>Tên hẻm:</Th>
                        <Td>{dinhGia?.tenHem}</Td>
                      </Tr>
                      <Tr>
                        <Th>Tên đường giao:</Th>
                        <Td>{dinhGia?.tenDuongGiao}</Td>
                      </Tr>
                      <Tr>
                        <Th>Phương pháp định giá:</Th>
                        <Td>{dinhGia?.phuongPhapDinhGia}</Td>
                      </Tr>
                      <Tr>
                        <Th>Hệ số tiếp giáp:</Th>
                        <Td>{dinhGia?.heSoTiepGiapDuong}</Td>
                      </Tr>
                      <Tr>
                        <Th>Tổng giá:</Th>
                        <Td>
                          {dinhGia?.tongGia
                            ? numberFormat(dinhGia?.tongGia || 0)
                            : ""}
                        </Td>
                      </Tr>
                      <Tr>
                        <Td>Đơn vị tính</Td>
                        <Td> 1.000 VNĐ</Td>
                      </Tr>
                    </Tbody>
                  </Table>
                </TableContainer>
              </Box>
              <Flex
                w="full"
                flexDirection="column"
                mt="20px"
                border="1px solid #fff"
                padding="5px"
                borderRadius="5px"
                boxShadow="base"
              >
                <TableContainer w="full">
                  <Table size="sm">
                    <Thead>
                      <Tr>
                        <Th>Vị trí</Th>
                        <Th>DT Khu Vực</Th>
                        <Th>MĐSD</Th>
                        <Th>Diện tích(m&sup2;)</Th>
                        <Th>Giá(1.000vnđ)</Th>
                        <Th></Th>
                      </Tr>
                    </Thead>
                    <Tbody>
                      {chiTiet.map((p, index) => {
                        return (
                          <Tr key={String(index)}>
                            <Td>{p.tenVung}</Td>
                            <Td>{p.dienTichVung}</Td>
                            <Td>
                              <Dropdown
                                data={mdsd}
                                selectedVal={p.mdsd}
                                onChange={(v) =>
                                  handleChangeValue(index, v, "MDSD")
                                }
                              />
                            </Td>
                            <Td w="15%">
                              <Input
                                value={p.dienTich}
                                type="number"
                                onChange={(e) =>
                                  handleChangeValue(
                                    index,
                                    e.target.value,
                                    "DIEN_TICH"
                                  )
                                }
                              />
                            </Td>
                            <Td w="25%">
                              <Input
                                value={p.gia}
                                onChange={(e) =>
                                  handleChangeValue(
                                    index,
                                    e.target.value,
                                    "GIA"
                                  )
                                }
                              />
                            </Td>
                          </Tr>
                        );
                      })}
                    </Tbody>
                  </Table>
                </TableContainer>
              </Flex>
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </Drawer>
    </>
  );
}
